/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RecipientStatus = {
    Active: 'active',
    Removed: 'removed',
} as const;
export type RecipientStatus = typeof RecipientStatus[keyof typeof RecipientStatus];


export function instanceOfRecipientStatus(value: any): boolean {
    for (const key in RecipientStatus) {
        if (Object.prototype.hasOwnProperty.call(RecipientStatus, key)) {
            if (RecipientStatus[key as keyof typeof RecipientStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecipientStatusFromJSON(json: any): RecipientStatus {
    return RecipientStatusFromJSONTyped(json, false);
}

export function RecipientStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientStatus {
    return json as RecipientStatus;
}

export function RecipientStatusToJSON(value?: RecipientStatus | null): any {
    return value as any;
}

export function RecipientStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RecipientStatus {
    return value as RecipientStatus;
}

